import React from 'react'
import { isEmpty, hhmmADoMMMYYYY } from '@fareye/utils'
import { Label, Flex, Modal } from '@fareye/ui'
import {
  TripDetailsGroup,
  TripLabel,
  TripLabelDetail
} from '../../../style/styled'
const regex = /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/
const Epod = ({ data }: any) => {
  const photos = Object.keys(data).filter(
    (key: string) =>
      key.includes('photo') && data[key] !== null && regex.test(data[key])
  )

  const [showModal, setShowModal] = React.useState({
    show: false,
    imageUrl: ''
  })
  return (
    <>
      {isEmpty(data) ? (
        <Label
          style={{
            width: '100%',
            paddingTop: '10vmax',
            textAlign: 'center',
            display: 'block'
          }}
        >
          No Records
        </Label>
      ) : (
        <Flex column>
          {data.epod_name ? (
            <TripDetailsGroup style={{ marginTop: '20px' }}>
              <TripLabel>Name</TripLabel>
              <TripLabelDetail>{data.epod_name}</TripLabelDetail>
            </TripDetailsGroup>
          ) : null}
          {data.epod_contact_num ? (
            <TripDetailsGroup>
              <TripLabel>Contact Number</TripLabel>
              <TripLabelDetail>{data.epod_contact_num}</TripLabelDetail>
            </TripDetailsGroup>
          ) : null}
          {data.epod_time ? (
            <TripDetailsGroup>
              <TripLabel>Time</TripLabel>
              <TripLabelDetail>
                {!['NA', null].includes(data?.epod_time)
                  ? hhmmADoMMMYYYY(data.epod_time)
                  : 'NA'}
              </TripLabelDetail>
            </TripDetailsGroup>
          ) : null}
          {data.epod_feedback ? (
            <TripDetailsGroup>
              <TripLabel>Feedback</TripLabel>
              <TripLabelDetail>{data.epod_feedback}</TripLabelDetail>
            </TripDetailsGroup>
          ) : null}
          {data.epod_coil ? (
            <TripDetailsGroup>
              <TripLabel>Coil</TripLabel>
              <TripLabelDetail>{data.epod_coil}</TripLabelDetail>
            </TripDetailsGroup>
          ) : null}
          {data.epod_edge ? (
            <TripDetailsGroup>
              <TripLabel>Edge</TripLabel>
              <TripLabelDetail>{data.epod_edge}</TripLabelDetail>
            </TripDetailsGroup>
          ) : null}
          {data.epod_rusty ? (
            <TripDetailsGroup>
              <TripLabel>Rusty</TripLabel>
              <TripLabelDetail>{data.epod_rusty}</TripLabelDetail>
            </TripDetailsGroup>
          ) : null}
          {data.epod_tarpuline ? (
            <TripDetailsGroup>
              <TripLabel>Tarpaulin</TripLabel>
              <TripLabelDetail>{data.epod_tarpuline}</TripLabelDetail>
            </TripDetailsGroup>
          ) : null}
          {data.epod_waterinside ? (
            <TripDetailsGroup>
              <TripLabel>Water Inside</TripLabel>
              <TripLabelDetail>{data.epod_waterinside}</TripLabelDetail>
            </TripDetailsGroup>
          ) : null}
          {data.epod_wateroutside ? (
            <TripDetailsGroup>
              <TripLabel>Water OutSide</TripLabel>
              <TripLabelDetail>{data.epod_wateroutside}</TripLabelDetail>
            </TripDetailsGroup>
          ) : null}
          {data.epod_weight_shortage ? (
            <TripDetailsGroup>
              <TripLabel>Weight Shortage</TripLabel>
              <TripLabelDetail>{data.epod_weight_shortage}</TripLabelDetail>
            </TripDetailsGroup>
          ) : null}
          {data.epod_whiterust ? (
            <TripDetailsGroup>
              <TripLabel>White Rust</TripLabel>
              <TripLabelDetail>{data.epod_whiterust}</TripLabelDetail>
            </TripDetailsGroup>
          ) : null}

          {data.epod_remarks ? (
            <TripDetailsGroup>
              <TripLabel>Remarks</TripLabel>
              <TripLabelDetail>{data.epod_remarks}</TripLabelDetail>
            </TripDetailsGroup>
          ) : null}
          {!isEmpty(photos) ? (
            <TripDetailsGroup>
              <TripLabel>Photos</TripLabel>
              <TripLabelDetail>
                {photos.map((item: string) => {
                  return data[item]
                    .split(';')
                    .map((url: string, index: number) => (
                      <img
                        src={url}
                        key={index}
                        style={{
                          objectFit: 'cover',
                          height: '100px',
                          cursor: 'pointer',
                          marginRight: '4px'
                        }}
                        onClick={() => {
                          setShowModal({ show: true, imageUrl: url })
                        }}
                      />
                    ))
                })}
              </TripLabelDetail>
            </TripDetailsGroup>
          ) : null}
          {data.epod_signature ? (
            <TripDetailsGroup>
              <TripLabel>Signature</TripLabel>
              <TripLabelDetail>
                {regex.test(data.epod_signature) ? (
                  <img
                    src={data.epod_signature}
                    style={{
                      objectFit: 'cover',
                      width: '60%',
                      height: '100px',
                      cursor: 'pointer'
                    }}
                    onClick={() => {
                      setShowModal({
                        show: true,
                        imageUrl: data.epod_signature
                      })
                    }}
                  />
                ) : (
                  <TripLabelDetail>{data.epod_signature}</TripLabelDetail>
                )}
              </TripLabelDetail>
            </TripDetailsGroup>
          ) : null}
        </Flex>
      )}
      <Modal
        variant={'m'}
        toggleModal={showModal.show}
        setToggleModal={(val: boolean) =>
          setShowModal({ ...showModal, show: val })
        }
        style={{
          backdrop: {
            background: 'rgba(255,255,255,.7)'
          },
          content: {
            boxShadow: '0 0 5px 1px rgba(128,128,128,1)',
            width: 'auto'
          }
        }}
      >
        <img src={showModal.imageUrl} />
      </Modal>
    </>
  )
}

export default Epod
